import styled, { css } from 'styled-components';

import { UpdateMessage } from 'libs/ui';

export const Content = styled.div`
  width: 590px;
  position: relative;
  margin: 0 0 1rem;
  form > div:last-child {
    margin-top: 20px;
  }
  ${(props) =>
    props.theme.ui === 'v2' &&
    css`
      width: 100%;
      max-width: none;
    `}
`;

export const Title = styled.p`
  border-bottom: solid 1px #595d64;
  padding: 0 0 15px 0;
  font-size: 20px;
  color: #fff;
  opacity: 0.6;
  &.nobrd {
    border: 0;
  }
  ${(props) =>
    props.theme.ui === 'v2' &&
    css`
      border-bottom-color: var(--cp-border);
      font-size: 16px;
      font-weight: 600;
      color: var(--cp-text);
      opacity: 1;
      padding-bottom: 12px;
      margin-bottom: 6px;
    `}
`;

export const UpdateMessageBox = styled(UpdateMessage)`
  bottom: -40px;
  left: 100px;
`;
